import * as React from "react"
const WorkIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    viewBox="0 0 512 512"
    {...props}
  >
    <title>{"work-case-filled"}</title>
    <path
      fillRule="evenodd"
      d="M42.667 261.76a554.667 554.667 0 0 0 170.666 36.907v42.666h85.334v-42.666a600.96 600.96 0 0 0 170.666-36.054v164.054H42.667V261.76ZM320 64l21.333 21.333V128h128v111.147a605.227 605.227 0 0 1-204.373 38.186H249.6A599.253 599.253 0 0 1 42.667 238.08V128h128V85.333L192 64h128Zm-21.333 42.667h-85.334V128h85.334v-21.333Z"
    />
  </svg>
)
export default WorkIcon
